import createIcon from '../../createIcon';

/**
 * @component @name Kitchen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOVY0QzIwIDIuOSAxOS4xIDIgMTggMkg2QzQuOSAyIDQgMi45IDQgNFY5SDIwWk04IDVIMTBWOEg4VjVaTTQgMTFWMjBDNCAyMS4xIDQuOSAyMiA2IDIySDE4QzE5LjEgMjIgMjAgMjEuMSAyMCAyMFYxMUg0Wk0xMCAxN0g4VjEySDEwVjE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Kitchen = createIcon('Kitchen', [
  [
    'path',
    {
      d: 'M20 9V4C20 2.9 19.1 2 18 2H6C4.9 2 4 2.9 4 4V9H20ZM8 5H10V8H8V5ZM4 11V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V11H4ZM10 17H8V12H10V17Z',
      key: '12mpcq',
    },
  ],
]);

export default Kitchen;
